import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "componentRef",
  class: "relative flex flex-col"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Box, _mergeProps({
      color: _ctx.color,
      variant: _ctx.variant,
      id: _ctx.id,
      label: _ctx.label,
      "aria-expanded": _ctx.open,
      "aria-haspopup": "true",
      class: "w-full md:w-auto inline-flex items-center justify-between cursor-pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = !_ctx.open))
    }, _ctx.$attrs), {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "label", {
          label: _ctx.label,
          open: _ctx.open,
          id: _ctx.id,
          toggle: _ctx.toggle
        }, () => [
          _createElementVNode("span", null, _toDisplayString(_ctx.label), 1),
          _createVNode(_component_Icon, {
            "aria-label": "Open dropdown",
            type: "solid",
            name: _ctx.open ? 'chevron-up' : 'chevron-down',
            class: "ml-2 w-5 h-5"
          }, null, 8, ["name"])
        ])
      ]),
      _: 3
    }, 16, ["color", "variant", "id", "label", "aria-expanded"]),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {
          id: _ctx.id,
          open: _ctx.open,
          toggle: _ctx.toggle
        })
      ]),
      _: 3
    })
  ], 512))
}